const SQM_PER_HECTARE = 10_000;

const DATE_FORMAT: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" };

function round(value: number): string {
  const digits = value >= 100 ? 0 : value >= 10 ? 1 : 2;
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
}

export const formatHectares = (squareMeters: number) =>
  `${round(squareMeters / SQM_PER_HECTARE)} ha`;

export function formatDate(date: Date | string): string {
  const value = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(value.getTime())) return String(date);
  return value.toLocaleDateString(undefined, DATE_FORMAT);
}

const WETLAND_TYPE_LABELS: Record<string, string> = {
  "marsh": "Marsh",
  "swamp": "Swamp",
  "bog": "Bog",
  "fen": "Fen",
  "string_bog": "String bog",
  "reedbed": "Reedbed",
  "wet_meadow": "Wet meadow",
  "saltmarsh": "Salt marsh",
  "tidalflat": "Tidal flat",
  "mangrove": "Mangrove",
  "saltern": "Saltern",
};

export const wetlandTypeLabel = (value: string | undefined): string | null =>
  (value && WETLAND_TYPE_LABELS[value]) || null;
